<template>
  <div id="app" ref="appRef"  v-cloak>
    <ScaleBox>
      <router-view />
    </ScaleBox>
  </div>
</template>
<script>
import ScaleBox from "./component/sacleBox.vue";
export default {
  components: {
    ScaleBox,
  },
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

[v-cloak] {
  display: none !important;
}

#app {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: #001624;
  font-family: "Microsoft YaHei";
  overflow: hidden;
}

li {
  list-style: none;
}
</style>
